import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { load as loadAccount } from '../Store/account';
import './Form.css';
import { useDispatch, useSelector } from 'react-redux';
import { elementActions } from '../Store/ElementSlice';
import NL from '../Data/NL';

import { Grid, Box } from '@material-ui/core';

let ReshydroForm = (props) => {
  const { handleSubmit, load, pristine, reset, submitting } = props;
  const dispatch = useDispatch();
  const [turbine_low_boundary_fraction, setTurbine_low_boundary_fraction] = useState();
  const [turbine_low_boundary_CAPEX, setTurbine_low_boundary_CAPEX] = useState();
  const [turbine_low_boundary_OPEX, setTurbine_low_boundary_OPEX] = useState();

  const ElementData = useSelector((state) => state.comp.components);

  let data = ElementData.filter((element) => element.id === props.id);

  useEffect(() => {
    load(data[0]?.data);
  }, [data, load]);

  const removeElementFromStore = (id) => {
    dispatch(elementActions.removeElement({ id }));
  };

  const updateData = (values) => {
    dispatch(elementActions.updateElementData({ values }));
  };

  const deleteElementHandler = (event) => {
    event.preventDefault();
    removeElementFromStore(props.id);
    props.togglePopup();
  };

  const [isRequired, SetIsRequired] = useState(true);

  const saveForLater = () => {
    SetIsRequired(false);
  };

  const setValidation = () => {
    dispatch(elementActions.SetFormValidatation(props.id));
  };

  return (
    <form
      onSubmit={handleSubmit((values) => {
        if (isRequired === true) {
          values.isValidated = true;
        } else {
          values.isValidated = false;
        }
        updateData(values);
        props.togglePopup();
      })}
    >
      <p className="Formtitle">Edit the parameters of {data[0].type} Component here:</p>
      <div>
        <label>ID:</label>
        <Field component="input" disabled name="id" type="text" />
      </div>
      <div>
        <label>Type:</label>
        <Field component="input" disabled name="type" type="text" />
      </div>
      <div>
        <label>Element color:</label>
        <Field component="input" name="color" type="text" placeholder="Enter the color of component" />
      </div>
      <div>
        <label>Name:</label>
        <Field
          component="input"
          name="label"
          type="text"
          id="FormName"
          required={isRequired}
          placeholder="Enter the Name"
        />
      </div>

      <label>Reservoir Parameters</label>
      <div className="form_container2">
        <div className="column">
          <div>
            <label>
              Capacity:
              <Field
                name="reservoir_capacity"
                component="input"
                type="number"
                step="0.1"
                required={isRequired}
                id="reservoir_capacity"
                value="10"
                className="opt"
                placeholder="10.0"
                min="10"
              />
              [units]
            </label>
          </div>
          <div>
            <label>
              Inst. Capex:
              <Field
                name="reservoir_CAPEX"
                component="input"
                type="number"
                step="0.1"
                required={isRequired}
                id="reservoir_CAPEX"
                value="10"
                className="opt"
                placeholder="10.0"
                min="10"
              />
              USD
            </label>
          </div>
          <div>
            <label>
              yearly OPEX:
              <Field
                name="reservoir_OPEX"
                component="input"
                type="number"
                step="0.1"
                required={isRequired}
                id="reservoir_OPEX"
                value="10"
                className="opt"
                placeholder="10.0"
                min="10"
              />
              USD/yr
            </label>
          </div>
        </div>
        <div className="column">
          <div>
            <label>
              Max Elevation:
              <Field
                name="reservoir_max_elevation"
                component="input"
                type="number"
                step="0.1"
                value="0"
                id="reservoir_max_elevation"
                className="opt"
                min="0.0"
                placeholder="10.0"
                required={isRequired}
              />
              m above ref point
            </label>
          </div>
          <div>
            <label>
              Min Elevation:
              <Field
                name="reservoir_min_elevation"
                component="input"
                type="number"
                step="0.1"
                id="reservoir_min_elevation"
                value="0"
                className="opt"
                placeholder="4.0"
                min="0"
                required={isRequired}
              />
              m above ref point
            </label>
          </div>
          <div>
            <label>
              Default initial status:
              <Field
                name="reservoir_init_status"
                component="input"
                type="number"
                step="0.1"
                id="reservoir_init_status"
                value="10"
                className="opt"
                placeholder="10.0"
                min="10"
                required={isRequired}
              />
              %
            </label>
          </div>
        </div>
      </div>
      <div className="form_container2">
        <div className="column">
          <div>
            <label>
              Riperian flow req.:
              <Field
                name="q_riperian"
                component="input"
                type="number"
                step="0.1"
                id="q_riperian"
                className="opt"
                value="0"
                placeholder="48.0"
                min="0"
                required={isRequired}
              />
              [units]
            </label>
          </div>
        </div>
        Elevation Vs Volume Non Linearity
        <Field
          component="select"
          name="reservoir_elevation_nl_id"
          className="dropdown"
          value="Linear"
          required={isRequired}
          id="reservoir_elevation_nl_id"
        >
          <option />
          {NL.map((data) => (
            <option key={data.id} value={data.id}>
              {data.name}
            </option>
          ))}
        </Field>
      </div>

      <label>Turbine Operations parameters</label>
      <div className="form_container2">
        <div className="column">
          <div>
            <label>
              Ramp up limit:
              <Field
                name="turbine_ramp_up_limit"
                id="turbine_ramp_up_limit"
                className="opt"
                component="input"
                required={isRequired}
                type="number"
                // component={renderField}
                step="0.1"
                min="10.0"
                value="10"
                placeholder="10.0"
              />
              %/hr
            </label>
          </div>
          <div>
            <label>
              Ramp down limit:
              <Field
                name="turbine_ramp_down_limit"
                component="input"
                type="number"
                step="0.1"
                id="turbine_ramp_down_limit"
                className="opt"
                min="10.0"
                required={isRequired}
                value="10"
                placeholder="10.0"
              />
              %/hr
            </label>
          </div>
          <div>
            <label>
              Default initial status:
              <Field
                name="turbine_initial_status"
                component="input"
                type="number"
                step="0.1"
                id="turbine_initial_status"
                value="10"
                className="opt"
                placeholder="10.0"
                min="10"
                required={isRequired}
              />
              %
            </label>
          </div>
          <div>
            <label>
              Min throttle:
              <Field
                name="turbine_min_throttle"
                component="input"
                type="number"
                step="0.1"
                value="0"
                id="turbine_min_throttle"
                className="opt"
                min="0.0"
                placeholder="10.0"
                required={isRequired}
              />
              %
            </label>
          </div>
        </div>
        <div className="column">
          <div>
            <label>
              max Q.:
              <Field
                name="turbine_max_q"
                component="input"
                type="number"
                step="0.1"
                id="turbine_max_q"
                className="opt"
                value="0"
                placeholder="48.0"
                min="0"
                required={isRequired}
              />
              [units]
            </label>
          </div>
          <div>
            <label>
              Max Elevation:
              <Field
                name="turbine_max_elevation"
                component="input"
                type="number"
                step="0.1"
                value="0"
                id="turbine_max_elevation"
                className="opt"
                min="0.0"
                placeholder="10.0"
                required={isRequired}
              />
              m above ref point
            </label>
          </div>
          <div>
            <label>
              Min Elevation:
              <Field
                name="turbine_min_elevation"
                component="input"
                type="number"
                step="0.1"
                id="turbine_min_elevation"
                value="0"
                className="opt"
                placeholder="4.0"
                min="0"
                required={isRequired}
              />
              m above ref point
            </label>
          </div>
        </div>
      </div>
      <label>Turbine Sampling size Boundaries and Non-Linearities:</label>
      <div className="form_container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid columns={1}></Grid>
          <Grid container spacing={2} columns={16}>
            <Grid item xs={2}></Grid>
            <Grid item xs={3}>
              <label>Low Boundary:</label>
            </Grid>
            <Grid item xs={3}>
              <label>High Boundary:</label>
            </Grid>
            <Grid item xs={4}>
              <label>Non Linearity:</label>
            </Grid>
          </Grid>
          <Grid container spacing={2} columns={16}>
            <Grid item xs={2}>
              <label> Physical Size: </label>
            </Grid>
            <Grid item xs={3}>
              <Field
                name="turbine_low_boundary_fraction"
                className="opt_input"
                component="input"
                type="number"
                step="0.1"
                value="1"
                onChange={(e) => {
                  setTurbine_low_boundary_fraction(e.target.value);
                }}
                min="1.0"
                id="turbine_low_boundary_fraction"
                required={isRequired}
                placeholder="1.0"
              />
              <p>% </p>
            </Grid>
            <Grid item xs={3}>
              <Field
                name="turbine_high_boundary_q"
                className="opt_input"
                component="input"
                type="number"
                step="0.1"
                value="1"
                disabled
                required={isRequired}
                min={turbine_low_boundary_fraction}
                id="high_boundary_capacity"
                placeholder="1.0"
              />
              <p> % </p>
            </Grid>
          </Grid>
          <Grid container spacing={2} columns={16}>
            <Grid item xs={2}>
              <label>Inst. CAPEX</label>
            </Grid>
            <Grid item xs={3}>
              <Field
                name="turbine_low_boundary_CAPEX"
                className="opt_input"
                component="input"
                type="number"
                value="1"
                onChange={(e) => {
                  setTurbine_low_boundary_CAPEX(e.target.value);
                }}
                min="1.000"
                required={isRequired}
                id="turbine_low_boundary_CAPEX"
                step="0.01"
                placeholder="1.000"
              />
              <p>USD</p>
            </Grid>
            <Grid item xs={3}>
              <Field
                name="turbine_high_boundary_CAPEX"
                component="input"
                className="opt_input"
                type="number"
                step="0.1"
                value="5"
                id="turbine_high_boundary_CAPEX"
                min={turbine_low_boundary_CAPEX}
                required={isRequired}
                placeholder="5.000"
              />
              <p>USD</p>
            </Grid>
            <Grid item xs={4}>
              <Field
                component="select"
                name="turbine_CAPEX_nl_id"
                className="dropdown"
                value="Linear"
                required={isRequired}
                id="turbine_CAPEX_nl_id"
              >
                <option />
                {NL.map((data) => (
                  <option key={data.id} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Field>
            </Grid>
          </Grid>
          <Grid container spacing={1} columns={16}>
            <Grid item xs={2}>
              <label>Yearly_OPEX</label>
            </Grid>
            <Grid item xs={3}>
              <Field
                name="turbine_low_boundary_OPEX"
                component="input"
                className="opt_input"
                type="number"
                step="0.01"
                value="25"
                onChange={(e) => {
                  setTurbine_low_boundary_OPEX(e.target.value);
                }}
                min="25.0"
                id="turbine_low_boundary_OPEX"
                placeholder="25"
                required={isRequired}
              />
              <p>USD/yr</p>
            </Grid>
            <Grid item xs={3}>
              <Field
                name="turbine_high_boundary_OPEX"
                component="input"
                type="number"
                step="0.1"
                className="opt_input"
                min={turbine_low_boundary_OPEX}
                value="55"
                id="turbine_high_boundary_OPEX"
                placeholder="55"
                required={isRequired}
              />
              <p>USD/yr</p>
            </Grid>
            <Grid item xs={4}>
              <Field
                component="select"
                name="turbine_OPEX_nl_id"
                className="dropdown"
                value="Linear"
                required={isRequired}
                id="turbine_OPEX_nl_id"
              >
                <option />
                {NL.map((data) => (
                  <option key={data.id} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Field>
            </Grid>
          </Grid>
        </Box>
      </div>
      <div className="form_container2">
        Output Elevation Vs turbine output flow:
        <Field
          component="select"
          name="turbine_elevation_nl_id"
          className="dropdown"
          value="Linear"
          required={isRequired}
          id="turbine_elevation_nl_id"
        >
          <option />
          {NL.map((data) => (
            <option key={data.id} value={data.id}>
              {data.name}
            </option>
          ))}
        </Field>
      </div>
      <label>spill flow:</label>

      <div className="form_container2">
        <div className="column">
          <div>
            <label>
              Max Flow:
              <Field
                name="spill_max_flow"
                component="input"
                type="number"
                step="0.1"
                id="spill_max_flow"
                value="0"
                className="opt"
                min="0.0"
                placeholder="10.0"
                required={isRequired}
              />
              m above ref point
            </label>
          </div>

          <div>
            <label>
              Min Elevation:
              <Field
                name="spill_flow_min_elevation"
                component="input"
                type="number"
                step="0.1"
                value="0"
                id="spill_flow_min_elevation"
                className="opt"
                placeholder="4.0"
                min="0"
                required={isRequired}
              />
              m above ref point
            </label>
          </div>
        </div>
        <div className="column">
          spill flow non linearities:
          <Field
            component="select"
            name="spill_flow_nl_id"
            className="dropdown"
            value="Linear"
            required={isRequired}
            id="spill_flow_nl_id"
          >
            <option />
            {NL.map((data) => (
              <option key={data.id} value={data.id}>
                {data.name}
              </option>
            ))}
          </Field>
        </div>
      </div>
      <div className="btn-ctn">
        <button type="submit" id="sub_form" disabled={pristine || submitting} onClick={setValidation}>
          Save
        </button>
        <button type="submit" id="save_later_form" onClick={saveForLater}>
          Save for Later
        </button>
        <button type="button" disabled={pristine || submitting} onClick={reset}>
          reset
        </button>
        <button type="Delbutton" onClick={deleteElementHandler}>
          Delete
        </button>
      </div>
    </form>
  );
};

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
ReshydroForm = reduxForm({
  form: 'reshydro',
  // a unique identifier for this form
})(ReshydroForm);

// // You have to connect() to any reducers that you wish to connect to yourself
ReshydroForm = connect(
  (state) => ({
    initialValues: state.account.data, // pull initial values from account reducer
  }),
  { load: loadAccount } // bind account loading action creator
)(ReshydroForm);

export default ReshydroForm;
